import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter
} from "react-router";
import styled from "styled-components";
import VenuePhotos from "sweet-web/components/PhotoBox/VenuePhotos";
import TabBar from "sweet-web/components/universal/TabBar";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import Activated from "./Activated";
import Finalize from "./Finalize";
import Header from "./Header";
import Information from "./Information";
import Payment from "./Payment";
import Photos from "./Photos";
import Preview from "./Preview";
import Admin from "./Admin";
import Services from "./Services";
import Settings from "./Settings";
import Spaces from "./Spaces";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
`;

type Props = ConnectedProps<typeof connector> & RouteComponentProps;

const ConstructListing: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venueActivated, userType } = props;

  let TABS: {
    name: string;
    title: string;
    path: string;
  }[] = [];

  if (userType === "VENUE") {
    TABS = [
      {
        name: "info",
        title: "Information",
        path: `/listing/${venueId}`
      },
      {
        name: "spaces",
        title: "Spaces",
        path: `/listing/${venueId}/spaces`
      },
      {
        name: "services",
        title: "Services",
        path: `/listing/${venueId}/services`
      },
      {
        name: "photos",
        title: "Photos",
        path: `/listing/${venueId}/photos`
      },
      {
        name: "payment",
        title: "Payment",
        path: `/listing/${venueId}/payment`
      }
    ];
    if (venueActivated)
      TABS.push({
        name: "settings",
        title: "Settings",
        path: `/listing/${venueId}/settings`
      });
    else
      TABS.push({
        name: "finalize",
        title: "Finalize",
        path: `/listing/${venueId}/finalize`
      });
  } else if (userType === "ADMIN") {
    TABS = [
      {
        name: "info",
        title: "Information",
        path: `/listing/${venueId}`
      },
      {
        name: "spaces",
        title: "Spaces",
        path: `/listing/${venueId}/spaces`
      },
      {
        name: "services",
        title: "Services",
        path: `/listing/${venueId}/services`
      },
      {
        name: "photos",
        title: "Photos",
        path: `/listing/${venueId}/photos`
      },
      {
        name: "admin",
        title: "Admin",
        path: `/listing/${venueId}/admin`
      }
    ];
  }

  return (
    <Wrapper>
      <Header />
      <TabBar tabs={TABS} url={props.match.url} />
      <Switch>
        <Route path="/listing/:venueId" exact={true} component={Information} />
        <Route
          path="/listing/:venueId/spaces"
          exact={true}
          component={Spaces}
        />
        <Route
          path="/listing/:venueId/services"
          exact={true}
          component={Services}
        />
        <Route
          path="/listing/:venueId/photos"
          exact={true}
          component={Photos}
        />
        <Route
          path="/listing/:venueId/payment"
          exact={true}
          component={Payment}
        />
        <Route
          path="/listing/:venueId/finalize"
          exact={true}
          component={Finalize}
        />
        <Route
          path="/listing/:venueId/settings"
          exact={true}
          component={Settings}
        />
        <Route
          path="/listing/:venueId/activated"
          exact={true}
          component={Activated}
        />
        <Route path="/listing/:venueId/admin" exact={true} component={Admin} />
      </Switch>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venueActivated: selectors.venueActivated(venueId)(state),
    userType: selectors.userType(state)
  };
};
const connector = connect(mapState);

export default connector(ConstructListing);
